var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isImage() === true
        ? [
            _c("v-img", {
              staticClass: "imageButton",
              attrs: {
                alt: _vm.element.caption,
                src: _vm.getImgUrl(_vm.element.icon)
              }
            })
          ]
        : _vm.isText() === true
        ? [_c("span", [_vm._v(_vm._s(_vm.element.caption))])]
        : _vm.isTextArea() === true
        ? [
            _c(
              "v-textarea",
              { attrs: { outlined: "", name: "input-7-4", label: "Mensaje" } },
              [_vm._v(_vm._s(_vm.element.value))]
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9a754a6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a754a6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diaryElements/BasicButton.vue
// module id = 252
// module chunks = 1